const data = [
    {
      Issues: "Disease",
      ConsultationStatus: "Confirmed",
      Date: "05/05/2024",
      Time: "1:00 pm",
      Amount: "18,000",
    },
    {
        Issues: "Physical Wellness",
        ConsultationStatus: "Pending",
        Date: "07/05/2024",
        Time: "12:00 am",
        Amount: "18,000",
    },
    {
        Issues: "Allergy",
        ConsultationStatus: "Confirmed",
        Date: "01/06/2024",
        Time: "12:30 am",
        Amount: "18,000",
    },
    {
        Issues: "Asthma",
        ConsultationStatus: "Cancelled",
        Date: "11/07/2024",
        Time: "02:30 am",
        Amount: "",
    },
    {
        Issues: "Asthma",
        ConsultationStatus: "Pending",
        Date: "11/07/2024",
        Time: "04:40 pm",
        Amount: "18,000",
    },
    {
        Issues: "Hypertension",
        ConsultationStatus: "Confirmed",
        Date: "05/05/2024",
        Time: "1:00 pm",
        Amount: "18,000",
      },
      {
          Issues: "Physical Wellness",
          ConsultationStatus: "Pending",
          Date: "07/05/2024",
          Time: "12:00 am",
          Amount: "18,000",
      },
      {
          Issues: "Allergy",
          ConsultationStatus: "Confirmed",
          Date: "01/06/2024",
          Time: "12:30 am",
          Amount: "18,000",
      },
      {
          Issues: "Asthma",
          ConsultationStatus: "Cancelled",
          Date: "11/07/2024",
          Time: "02:30 am",
          Amount: "",
      },
      {
          Issues: "Malaria",
          ConsultationStatus: "Pending",
          Date: "11/07/2024",
          Time: "04:40 pm",
          Amount: "18,000",
      },
  ];
  
  export default data;
  